import clsx from 'clsx';
import { TableHeaderConfig } from 'types/table/TableHeaderConfig.type';
import styles from '../../components/organisms/documents-required-table/documents-required-table.module.scss';

export interface DocumentsRequiredColumns {
  documentName: string;
  requestDate: Date;
}

export const documentsRequestTableHeaderData: TableHeaderConfig<DocumentsRequiredColumns>[] = [
  {
    key: 'documentName',
    label: 'Document name',
    className: clsx(styles.header),
    allowSorting: false
  },
  {
    key: 'requestDate',
    label: 'Date requested',
    className: clsx([styles.header, styles.dateHeader]),
    allowSorting: false
  }
];
